"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var AutoSuggestItem =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AutoSuggestItem, _PureComponent);

  function AutoSuggestItem() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AutoSuggestItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AutoSuggestItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onClick", function (evt) {
      evt.preventDefault();
      var _this$props = _this.props,
          suggestion = _this$props.suggestion,
          onSuggestionSelect = _this$props.onSuggestionSelect;

      if (onSuggestionSelect) {
        onSuggestionSelect(suggestion);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AutoSuggestItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          className = _this$props2.className,
          suggestion = _this$props2.suggestion,
          onSuggestionMouseDown = _this$props2.onSuggestionMouseDown,
          onSuggestionMouseOut = _this$props2.onSuggestionMouseOut;
      var classes = (0, _classnames.default)('AutoSuggestInput-item', {
        'AutoSuggestInput-item-active': active
      }, className);
      return _react.default.createElement("li", {
        className: classes,
        onClick: this._onClick,
        onMouseDown: onSuggestionMouseDown,
        onMouseOut: onSuggestionMouseOut
      }, suggestion.label);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return AutoSuggestItem;
}(_react.PureComponent);

exports.default = AutoSuggestItem;
(0, _defineProperty2.default)(AutoSuggestItem, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** Whether or not the suggestion item is active. */
  active: _propTypes.default.bool,

  /** The suggestion data object. */
  suggestion: _propTypes.default.shape({
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  }).isRequired,

  /** Optional function to execute when a suggestion is selected. */
  onSuggestionSelect: _propTypes.default.func,

  /** Optional function to execute for suggestion list item's mousedown event. */
  onSuggestionMouseDown: _propTypes.default.func,

  /** Optional function to execute for suggestion list item's mouseout event. */
  onSuggestionMouseOut: _propTypes.default.func
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AutoSuggestItem, "AutoSuggestItem", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/AutoSuggestInput/AutoSuggestItem.jsx");
  leaveModule(module);
})();

;